module.exports = "<div style=\"font-family:fontRegular;padding:15px 70px;font-size: 16px;color : red;text-align: center\">\n    {{message}}\n</div>"